import { Colourway } from './colourway';
import { ModelBase } from './model-base';
import { NavItem } from './nav-item.model';
import { ReferenceIntakeProfile } from './reference-intake-profile';
import { Splashscreen } from './splashscreen';
import { TagGroup } from './tag-groups';


export class Settings extends ModelBase {
    id: number;
    customerGroupId: number;
    subdomain: string;
    enabled: boolean;
    footerText: string;
    contactEmailAddress: string;
    contactPhone: string;
    websiteUrl: string;
    showNutritionalInfo: boolean;
    disableRecipePhotos: boolean;
    showRecipeYield: boolean;
    showRecipeDescriptions: boolean;

    // The customer's own disclaimer
    disclaimer: string;

    // returns true when the disclaimer must be shown before any recipes
    forceDisclaimer: boolean;
    keyColour: string;
    logoImage: number;
    brandingImage: string;
    splashScreenImage: string;
    selectedSplashScreenImage: number;
    searchRecipes: boolean;
    browseMenuCycles: boolean;
    useMenuCycleCalendar: boolean;
    limitRecipesToMenuCycles: boolean;
    usePicnicSchedule: boolean;

    disabledMessage: string;

    siteIds: number[];
    showPrices: boolean;
    referenceIntakeProfiles: ReferenceIntakeProfile[];
    showCo2eValues: boolean;

    tagGroups: TagGroup[];

    navItems: NavItem[] | null;

    constructor(s?: Partial<Settings>) {
        super(s);
        if (s) {
            if (!s.brandingImage) {
                this.brandingImage = Colourway.grayBlue.toString(); // setting default colourway
            }
            if (!s.selectedSplashScreenImage) {
                this.selectedSplashScreenImage = Splashscreen.default; // setting default colourway
            }
            if (s.referenceIntakeProfiles) this.referenceIntakeProfiles = s.referenceIntakeProfiles.map(x => new ReferenceIntakeProfile(x));
        }
    }
}
